module.exports = __webpack_public_path__ + "media/A_level1_loop.e644bf5c.mp3";